export * from './input.component';
export * from './input.module';